import { cx } from "components/Graphs/utils";
import React from "react";

import OrganizationContextSwitcher from "../OrganizationContextSwitcher";
import type { ShellOrganization } from "../types";

export interface WorkspaceContextBreadcrumbProps {
  organizations: readonly ShellOrganization[];
  activeOrganizationId: string;
  onOrganizationChange: (organization: ShellOrganization) => void;
  onCreateOrganization?: () => void;
  onManageOrganization?: () => void;
  className?: string;
}

export const WorkspaceContextBreadcrumb: React.FC<
  WorkspaceContextBreadcrumbProps
> = ({
  organizations,
  activeOrganizationId,
  onOrganizationChange,
  onCreateOrganization,
  onManageOrganization,
  className,
}) => (
  <nav
    aria-label="Workspace context"
    className={cx("flex min-w-0 items-center gap-1", className)}
  >
    <OrganizationContextSwitcher
      organizations={organizations}
      activeOrganizationId={activeOrganizationId}
      onOrganizationChange={onOrganizationChange}
      onCreateOrganization={onCreateOrganization}
      onManageOrganization={onManageOrganization}
    />
  </nav>
);

WorkspaceContextBreadcrumb.displayName = "WorkspaceContextBreadcrumb";

export default WorkspaceContextBreadcrumb;
